/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { Input, InputNumber } from "antd";

const content = {
  numofeffectsite: {
    label: "จำนวน Site ที่มีผลกระทบ / Site",
    value: "",
  },
  siteid: {
    label: "Site ID",
    value: "",
  },
};
export default function Effectsite({
  title,
  formdata,
  valuechange,
  numberchange,
  language,
  factupdate,
}) {
  const locale = Cookies.get("locale");
  return (
    // <div
    //   className="col-lg-4 mt-4 pb-5 mr-4 ml-4"
    //   style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
    // >
    //   <div className="row pr-5 mt-3">
    //     <img
    //       src={Api.absoluteUrl(`/icon/bbtec/body/Site-Effect.svg`)}
    //       alt={title}
    //       title={title}
    //       className="mr-2 mb-1"
    //     />
    //     <span className="font-thai-b fs-22">{title}</span>
    //   </div>
    //   <div className="row mt-3">
    //     <div className="col-12">
    //       <div className="row">
    //         <div className="col-lg-10">
    //           <div className="row">
    //             <span className="font-thai-r fs-18 c-gray">
    //               {factupdate
    //                 ? language[locale]["numof_effectsite"]
    //                 : content.numofeffectsite.label}
    //             </span>
    //           </div>
    //           <div className="row">
    //             <div className="col-lg-4">
    //               <InputNumber
    //                 name="numofeffectsite"
    //                 className="c-blue"
    //                 value={formdata.numofeffectsite}
    //                 onChange={numberchange}
    //               ></InputNumber>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="row mt-2">
    //         <div className="col col-4">
    //           <span className="font-thai-r fs-18 c-gray">
    //             {factupdate
    //               ? language[locale]["site_id"]
    //               : content.siteid.label}
    //           </span>
    //         </div>
    //         <div className="col col-8">
    //           <Input
    //             name="effectsiteid"
    //             className="c-blue font-thai-r"
    //             value={formdata.effectsiteid}
    //             onChange={valuechange}
    //           ></Input>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div
      className="col-lg-4 mt-4 pb-5 mr-4 ml-4"
      style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
    >
      <div className="row pr-5 mt-3">
        <img
          src={Api.absoluteUrl("/icon/bbtec/body/Site-Effect.svg")}
          className="mr-2 mb-1"
        ></img>
        <span className="font-thai-b fs-22">{title}</span>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="row">
            <div className="col-lg-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["numof_effectsite"]
                    : content.numofeffectsite.label}
                </span>
              </div>
              <div className="row">
                <InputNumber
                  disabled={formdata.IsHold || false}
                  name="numofeffectsite"
                  className="c-blue"
                  value={formdata.numofeffectsite}
                  onChange={numberchange}
                ></InputNumber>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-10">
              <div className="row mt-2">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["site_id"]
                    : content.siteid.label}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled={formdata.IsHold || false}
                  name="effectsiteid"
                  className="c-blue font-thai-r"
                  value={formdata.effectsiteid}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
